import React, { useEffect, useState } from "react";
import { Form,  Input,  Modal,  DatePicker,  theme,  Row, Select, Spin ,} from "antd";
import { POST } from "../../frameworks/HttpClient";
import { URL_SKIM } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import { PRIMARY_COLOR } from "../../constants/color";
import { DATETIME_FORMAT } from "../../constants/string";
import dayjs from "dayjs";
import useDropdownItem from "../../common/useDropdownItem";
import _ from "lodash";

export default function CoagulationSkimModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = useState(null);
  const [debouncedChemicalLot, setDebouncedChemicalLot] = React.useState('');
  const debounceChemicalLot = React.useCallback(_.debounce((_searchVal) => { setDebouncedChemicalLot(_searchVal) }, 800), []);

  const chemicalLotDropdown = useDropdownItem({
    url: URL_SKIM.SKIM_CHEMICAL_TRANSACTION,
    manual : true, value:'id', pagination: true, 
    label_renderer : (e) => {return `${e.lot_no}- ${e.chemical_name}`}, 
    params: { page_size: 999, name: debouncedChemicalLot, is_closed: false } 
  })

  useEffect(() => {
    if (target) {
      setErrorMessages(null)
      form.setFieldsValue(target)
    } else {
      form.resetFields();
    }
  }, [open]);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      data['transaction'] = target.id
      await POST(URL_SKIM.SKIM_INPUT_CHEMICAL_TRANSACTION, data);
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if(open)
      chemicalLotDropdown.fetchOptions();
  },[open])

  React.useEffect(() => {
    if(open)
      chemicalLotDropdown.fetchOptions();
  },[debouncedChemicalLot])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={"ยืนยัน"}
      cancelText="ยกเลิก"
      title={"ยางจับตัว"}
      width={420}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: PRIMARY_COLOR },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages} />

      <Form form={form} layout="vertical">
        <Row gutter={10}>
          <Form.Item
            label="วันที่จับตัว"
            name="thicken"
            rules={[{  required: true, message : 'กรุณากรอกข้อมูล'}]}
            style={{ width: '100%' }}
            getValueProps={(value) => ({ value: value && dayjs(value, DATETIME_FORMAT) })}
            // normalize={(value) => value ? dateToString(value) : null}
          >
            <DatePicker 
              showTime={{
                format: "HH:mm",
              }}
              format="YYYY-MM-DD HH:mm"
              style={{ width : '100%' }} 
              placeholder="วันที่จับตัว"
            />
          </Form.Item>
          <Form.Item
            label="ล็อตสารเคมี"
            name="chemical"
            rules={[{  required: true, message : 'กรุณากรอกข้อมูล'}]}
            style={{ width: '100%' }}
          >
              <Select 
                showSearch
                style={{ width : '100%' }} 
                placeholder={'ชื่อสารเคมี'} 
                options={chemicalLotDropdown.options}
                filterOption={false}
                notFoundContent={chemicalLotDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceChemicalLot}
              />
          </Form.Item>
          <Form.Item
            label="ปริมาณกรด"
            name="thickening_amount"
            rules={[{  required: true, message : 'กรุณากรอกข้อมูล'}]}
            style={{ width: '100%' }}
          >
            <Input placeholder="ปริมาณกรด"/>
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
}
  